module.exports = __webpack_public_path__ + "img/local-92-logo.93a2252f.jpg";